'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { ProcedureForm } from '../-components/ProcedureForm';
import { ProcedurePageShell } from '../-components/ProcedurePageShell';
import type { ProcedureFormSchema } from '../-schema';

// 退職手続き（従業員起点の「退職申請」）。新ポータルでは本人がポータルから退職を申請できる
// （allowIndividualRequest 有効パッケージ）前提。会社起点の運用も併存できるため、本フォームは
// 本人が「希望」を出す形で組む：退職日は会社確定値ではなく本人入力の「退職希望日」。
// 正式な離職区分の確定・行政申請は労務側の退職手続きが担う（本人フォームには載せない）。
const OFFBOARDING_SCHEMA: ProcedureFormSchema = {
  title: '退職手続き',
  personName: '安西 優',
  personBadges: ['正社員', '在籍中'],
  personMeta: [{
    label: '退職希望日',
    value: '2026年6月30日',
    emphasized: true
  }, {
    label: '従業員番号',
    value: '798'
  }, {
    label: '配属',
    value: 'プロモーション部 Web広告運用・リスティング'
  }],
  submitLabel: '退職申請を提出する',
  submittedMessage: '退職申請を提出しました。労務担当が内容を確認します。',
  flow: 'application',
  requestId: 'ipr-offboarding',
  requestName: '退職申請',
  requestTotalSteps: 3,
  route: '/individual/portal/procedures/offboarding',
  sections: [{
    id: 'resignation-request',
    title: '① 退職の希望',
    description: 'ご希望の退職日を入力してください。労務担当が確認のうえ、正式な退職日を確定します。',
    fields: [{
      kind: 'date',
      id: 'desiredResignationDate',
      label: '退職希望日',
      required: true,
      defaultValue: '2026-06-30'
    }, {
      kind: 'date',
      id: 'desiredLastWorkingDate',
      label: '最終出社希望日',
      defaultValue: '2026-06-25'
    }]
  }, {
    id: 'post-contact',
    title: '② 退職後の連絡先',
    description: '退職後に会社から連絡・書類送付を行う際の宛先です。',
    fields: [{
      kind: 'text',
      id: 'email',
      label: 'メールアドレス',
      required: true,
      defaultValue: 'yu.anzai@gmail.com'
    }, {
      kind: 'text',
      id: 'phone',
      label: '電話番号',
      required: true,
      defaultValue: '0800-000-0000'
    }, {
      kind: 'text',
      id: 'postalCode',
      label: '郵便番号',
      defaultValue: '096-6833'
    }, {
      kind: 'text',
      id: 'prefecture',
      label: '都道府県',
      defaultValue: '東京都'
    }, {
      kind: 'text',
      id: 'city',
      label: '市区町村',
      defaultValue: '港区'
    }, {
      kind: 'text',
      id: 'address',
      label: '番地',
      defaultValue: '6丁目7番8号'
    }, {
      kind: 'text',
      id: 'building',
      label: '建物名・部屋番号',
      defaultValue: '795号室'
    }]
  }, {
    id: 'issuance',
    title: '③ 発行・届出の希望',
    description: '退職に伴い必要な書類の交付・発行を選択してください。',
    fields: [{
      kind: 'radio',
      id: 'separationSlip',
      label: '離職票の交付希望',
      required: true,
      defaultValue: 'request',
      options: [{
        value: 'request',
        label: '交付を希望する'
      }, {
        value: 'no',
        label: '希望しない'
      }]
    }, {
      kind: 'radio',
      id: 'healthInsuranceCert',
      label: '健康保険 資格喪失証明書の発行',
      defaultValue: 'request',
      options: [{
        value: 'request',
        label: '発行を希望する'
      }, {
        value: 'no',
        label: '希望しない'
      }]
    }, {
      kind: 'radio',
      id: 'employmentCert',
      label: '退職証明書の発行',
      defaultValue: 'no',
      options: [{
        value: 'request',
        label: '希望する'
      }, {
        value: 'no',
        label: '希望しない'
      }]
    }, {
      kind: 'radio',
      id: 'residentTax',
      label: '退職後の住民税の徴収方法',
      defaultValue: 'ordinary',
      options: [{
        value: 'ordinary',
        label: '普通徴収に切り替え'
      }, {
        value: 'special',
        label: '転職先で特別徴収'
      }]
    }]
  }]
};
export const Route = createFileRoute('/_individual/individual/portal/procedures/offboarding/')({
  component: OffboardingPage
});
function OffboardingPage() {
  return <ProcedurePageShell>
      <ProcedureForm schema={OFFBOARDING_SCHEMA} />
    </ProcedurePageShell>;
}